import Tooltip from 'components/tooltip/Tooltip';
import { Typography } from 'foundations/typography';
import React from 'react';

const WithTooltip = (props) => {
    const {
        tooltip,
        place,
        children,
        offset,
        className,
        style,
        clickable,
        enableTimeout,
        toolClass,
        renderElement,
        tooltipContentProps = {},
        containerId = '',
    } = props;
    return tooltip || renderElement ? (
        <Tooltip
            type='iconInfo'
            toolClass={toolClass ? toolClass : 'summitTooltip'}
            className={className}
            style={style}
            place={place}
            containerId={containerId}
            renderElement={
                renderElement ? (
                    renderElement
                ) : (
                    <Typography
                        variant='subtext2'
                        color='ambience.21'
                        {...(tooltipContentProps || {})}
                    >
                        {tooltip}
                    </Typography>
                )
            }
            renderTrigger={children}
            offset={offset}
            clickable={clickable}
            enableTimeout={enableTimeout}
        />
    ) : (
        children
    );
};

export default WithTooltip;
